import { render, staticRenderFns } from "./tempForm.vue?vue&type=template&id=f08af1e0&"
import script from "./tempForm.vue?vue&type=script&lang=js&"
export * from "./tempForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports